// Generat automat din README.md
import React from 'react';

const Card = ({ 
  children, 
  className = '', 
  title, 
  subtitle, 
  icon: Icon,
  variant = 'default',
  hoverable = true 
}) => {
  const cardClass = variant === 'stats' ? 'card-stats' : 'card';
  const hoverClass = hoverable ? 'hover-lift' : '';
  
  return (
    <div className={`${cardClass} ${hoverClass} animate-in ${className}`}>
      {(title || Icon) && (
        <div className="flex items-center mb-4 sm:mb-6">
          {Icon && (
            <div className="flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 bg-primary-100 dark:bg-primary-900/50 rounded-lg sm:rounded-xl mr-3 sm:mr-4 flex-shrink-0">
              <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-primary-600 dark:text-primary-400" />
            </div>
          )}
          <div className="flex-1 min-w-0">
            {title && (
              <h3 className="text-base sm:text-lg font-semibold text-gray-900 dark:text-white leading-tight truncate">
                {title}
              </h3>
            )}
            {subtitle && (
              <p className="text-xs sm:text-sm text-gray-500 dark:text-gray-400 mt-1 truncate">
                {subtitle}
              </p>
            )}
          </div>
        </div>
      )}
      <div className="space-y-3 sm:space-y-4">
        {children}
      </div>
    </div>
  );
};

export default Card;
